import React from 'react'
import { InfoContent, InfoLabel, InfoRow } from '@/components/InfoRow'
import Resx from '@/components/Resx'
import { Link } from 'react-router-dom'
import { formatDate, defaultDateTimeFormat } from '@/utils/dateUtilities'
import Name from '@/components/Name'
import { WhiteBox } from '@/components/Layout'
import { Button } from '@/components/button'
import { DataLoader } from '@/components/dataLoader'
import context from '@/context'
import LoadingIndicator from '@/components/LoadingIndicator'
import { TaskResultData, ChangeRequestTaskResult } from './taskResultData'
import { transformTask } from '@/utils/tasks'
import { ApprovalResult } from './approvalResult'

const RelatedTask = React.memo(function RelatedTask ({ task }) {
  const approveChangeRequestWithoutTask = task && !task.relatedTaskId && task.changeRequestId && !task.data.resultType

  if (approveChangeRequestWithoutTask) {
    return (
      <WhiteBox
        dataCy='ChangeRequest'
        header={<React.Fragment>
          <Resx name='Tasks.ChangeRequest' />
          <ApprovalResult task={task} />
        </React.Fragment>}
      >
        <ChangeRequestTaskResult changeRequest={task.changeRequest} checkerUserId={task.assignedToUserId} hideTitle />
      </WhiteBox>
    )
  }
  if (!task || !task.relatedTaskId) return null
  let relatedTaskLoader = null
  return (
    <WhiteBox
      dataCy='RelatedTicket'
      header={<React.Fragment>
        <Resx name='Tasks.RelatedTask' />
        <ApprovalResult task={task} />
      </React.Fragment>}
      buttons={<React.Fragment>
        <Button color='success' size='sm' icon='revision' onClick={() => relatedTaskLoader.loadData()} />
      </React.Fragment>}
    >
      <DataLoader ref={ref => {
        relatedTaskLoader = ref
      }} dataSource={() => context.api.taskService.getMyTask(task.relatedTaskId, {}).then(transformTask)} render={x =>
        x.loading
          ? <LoadingIndicator />
          : <RelatedTaskContent task={x.data} checkerUserId={task.assignedToUserId} />
      } />
    </WhiteBox>
  )
})

const RelatedTaskContent = React.memo(function RelatedTaskContent ({ task, checkerUserId }) {
  return (
    <React.Fragment>
      <InfoRow>
        <InfoLabel size='sm'><Resx name='Common.Id' /> </InfoLabel>
        <InfoContent><Link to={`/tasks/${task.id}`}>{task.id}</Link></InfoContent>
      </InfoRow>
      <InfoRow>
        <InfoLabel size='sm'><Resx name='Tasks.Type' /></InfoLabel>
        <InfoContent><Name data={task.type} /></InfoContent>
      </InfoRow>
      <InfoRow>
        <InfoLabel size='sm'><Resx name='Tasks.AssignedTo' /></InfoLabel>
        <InfoContent>{task.assignedTo}</InfoContent>
      </InfoRow>
      <InfoRow>
        <InfoLabel size='sm'><Resx name='Tasks.DueDate' /></InfoLabel>
        <InfoContent>{formatDate(task.dueDate)}</InfoContent>
      </InfoRow>
      <InfoRow>
        <InfoLabel size='sm'><Resx name='Tasks.CompletedTime' /></InfoLabel>
        <InfoContent>{formatDate(task.lastModificationTime, defaultDateTimeFormat)}</InfoContent>
      </InfoRow>
      <br /> {/* TODO: Prestylovat misto BR */}
      <TaskResultData task={task} checkerUserId={checkerUserId} />
    </React.Fragment>
  )
})

export {
  RelatedTask
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/tasks/relatedTask.js